import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import RefreshIcon from '@mui/icons-material/Refresh';

const ErrorScreen = ({ onRetry, errorMessage }) => {
  return (
    <div className="error-screen" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={6}>
            <img 
              src="/sdg-logo/logo-horizontal.png" 
              alt="Kosovo SDG Logo" 
              style={{ 
                maxWidth: '300px', 
                marginBottom: '2rem' 
              }} 
            />
            <div style={{
              backgroundColor: '#fff3cd',
              border: '2px solid #ffc107',
              borderRadius: '8px',
              padding: '2rem',
              marginBottom: '2rem'
            }}>
              <h3 style={{ color: '#856404', marginBottom: '1rem', fontWeight: 600 }}>
                Unable to Connect to Data Server
              </h3>
              <p style={{ color: '#856404', marginBottom: '1rem', fontSize: '1.1rem' }}>
                {errorMessage || 'There seems to be an issue with the data server. Please try again later.'}
              </p>
              <p style={{ color: '#856404', fontSize: '0.9rem', marginBottom: 0 }}>
                If this problem persists, please contact support.
              </p>
            </div>
            <Button
              variant="primary"
              size="lg"
              onClick={onRetry}
              style={{
                backgroundColor: '#039dda',
                borderColor: '#039dda',
                padding: '0.75rem 2rem',
                fontSize: '1.1rem',
                fontWeight: 600
              }}
            >
              <RefreshIcon style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
              Try Again
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ErrorScreen;

